import type { Variants } from '@ds/components/Tag'
import { VariantsEnum } from '@ds/components/Tag/Tag.constant'

import translations from '../composables/Status.translations'

export const STATUS = {
  CANCELLED: 'CANCELLED',
  COUNTER_OFFER: 'COUNTER_OFFER',
  MONEY_TRANSFERRED: 'MONEY_TRANSFERRED',
  CREATED: 'CREATED',
  PAID: 'PAID',
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
  SENT: 'SENT',
  SUSPENDED: 'SUSPENDED',
  TO_SEND: 'TO_SEND',
  VALIDATED: 'VALIDATED',
}

export const STATUS_COLOR_VARIANT: Record<string, Variants> = {
  [STATUS.CANCELLED]: VariantsEnum.Danger,
  [STATUS.COUNTER_OFFER]: VariantsEnum.Warning,
  [STATUS.MONEY_TRANSFERRED]: VariantsEnum.Success,
  [STATUS.CREATED]: VariantsEnum.Secondary,
  [STATUS.PAID]: VariantsEnum.Success,
  [STATUS.PENDING]: VariantsEnum.Secondary,
  [STATUS.RECEIVED]: VariantsEnum.Secondary,
  [STATUS.SENT]: VariantsEnum.Secondary,
  [STATUS.SUSPENDED]: VariantsEnum.Warning,
  [STATUS.TO_SEND]: VariantsEnum.Secondary,
  [STATUS.VALIDATED]: VariantsEnum.Success,
}

export const STATUS_TRANSLATIONS = {
  [STATUS.CANCELLED]: translations.canceled,
  [STATUS.COUNTER_OFFER]: translations.counterProposal,
  [STATUS.MONEY_TRANSFERRED]: translations.moneyTransfered,
  [STATUS.CREATED]: translations.new,
  [STATUS.PAID]: translations.paid,
  [STATUS.PENDING]: translations.pending,
  [STATUS.RECEIVED]: translations.received,
  [STATUS.SENT]: translations.sent,
  [STATUS.SUSPENDED]: translations.suspended,
  [STATUS.TO_SEND]: translations.toSend,
  [STATUS.VALIDATED]: translations.validated,
}
